import { ReactComponent as BaseCorp } from "../../assets/icons/companylogo.svg";
import sidemenucss from "../../css/sidemenu.module.css";
import { useHistory } from "react-router-dom";
import { getCompanybyId } from "../../../Console/Component/services/apiHandler";
import { useState, useEffect } from "react";

const CompanyEditSideMenu = ({ activeTab, companyID, setcompanyName, companyDataCheck = false, subMenuItem }) => {
  
  const [hideUnHideSubMenu, sethideUnHideSubMenu] = useState('A')
  const [companyData, setCompanyData] = useState("");
  const [menuCompanyName, setmenuCompanyName] = useState("");

  const redirectTo = (link) => {
    window.location.href = link;
  };

  const routerHistory = useHistory();
  const handleClick = (Link) => {
    routerHistory.push(Link);
  };

  useEffect(()=>{
    getCompanyDetails();
  },[companyID])

  const getCompanyDetails = () => {
    getCompanybyId(companyID)
      .then((response) => {
        if (response.data.getOneCompany[0]) {
          setCompanyData(response.data.getOneCompany[0]);
          if (response.data.getOneCompany[0]) {
            const compDt = response.data.getOneCompany[0];
            console.log('compDt :: ',compDt);
            setCompanyData(companyDataCheck);
            if (companyDataCheck) {
              setmenuCompanyName(compDt?.company_name)
              setcompanyName(compDt?.company_name);
            }
          }

        }
      })
      .catch((error) => {
        setCompanyData("");
      });
  };

  useEffect(() => {
    console.log('menuCompanyName :: ',menuCompanyName);
  },[menuCompanyName])

  const menuItems = [
    {
      label: "Company Details",
      pagelink: `/myfinV2/company-details/${companyID}`,
    },
    { label: "ERP Linking", pagelink: `/myfinV2/erp-connectors/${companyID}` },
    {
      label: "Accounting Policies",
      pagelink: `/myfinV2/accounting-policy/${companyID}`,
    },
    { 
      label: "Database",
       pagelink: `/myfinV2/database/${companyID}` 
    },
    // { 
    //   label: "Definitions",
    //   pagelink: `/myfinV2/definitions/${companyID}` 
    // },
    // { 
    //   label: "Receivable Definitions", 
    //   pagelink: `/myfinV2/receivables-definitions/${companyID}` 
    // },
    {key: 3,
        label: "Definitions",
        pagelink: `/myfinV2/definitions/${companyID}`,
        subMenu: [
            { label: "Loan Register",
              pagelink: `/myfinV2/definitions/${companyID}` 
            },
            { 
              label: "Receivable Regiser", 
              pagelink: `/myfinV2/receivables-definitions/${companyID}` 
            }
        ]
    },
  ];

  const subMenu = () => {
        // if (hideUnHideSubMenu === 'A') {
        //     sethideUnHideSubMenu('I');
        // } 
        // else {
        //     sethideUnHideSubMenu('A');
        // }
    }

    
  const activeItem = activeTab;
  const activeItemSubMenu = subMenuItem

  return (

    // <div
    //   className={`${sidemenucss.sidemenuContainer} ${sidemenucss.sidemenuBackgroundClr}`}
    // >
    //   <div className={sidemenucss.sidemenuHeader}>
    //     <BaseCorp className={sidemenucss.sidemenuCompanyLogoSize} />
    //     <span className={sidemenucss.sidemenuTitle}>{companyData?.company_name}</span>
    //   </div>
    //   <div
    //     className={`${sidemenucss.sidemenuContent} ${sidemenucss.sidemenuLinksFontSize} ${sidemenucss.sidemenuContentTop}`}
    //   >
    //     <ul className={sidemenucss.sidemenuList}>
    //       {menuItems.map((item, index) => (
    //         <li
    //           key={index}
    //           onClick={() => {
    //             handleClick(item.pagelink);
    //           }}
    //           className={`${sidemenucss.sidemenuItem} ${
    //             activeItem === item.label ? sidemenucss.sidemenuItemActive : ""
    //           }`}
    //         >
    //           <span className={sidemenucss.sidemenuItemname}>
    //             {" "}
    //             {item.label}
    //           </span>
    //         </li>
    //       ))}
    //     </ul>
    //   </div>
    // </div>

    <div className={`${sidemenucss.sidemenuContainer} ${sidemenucss.sidemenuBackgroundClr}`}>
      <div className={sidemenucss.sidemenuHeader}>
          <BaseCorp className={sidemenucss.sidemenuCompanyLogoSize} />
          <span className={sidemenucss.sidemenuTitle}>{menuCompanyName}</span>
          {/* <span className={sidemenucss.sidemenuTitle}>{companyData?.company_name}</span> */}
      </div>
      <div className={`${sidemenucss.sidemenuContent} ${sidemenucss.sidemenuLinksFontSize} ${sidemenucss.sidemenuContentTop}`}>
          <ul className={sidemenucss.sidemenuList}>
              {menuItems.map((item, index) => (
              
                  <div key={index}>
                      <li
                          onClick={() => {
                              subMenu();
                              if (item.pagelink) {
                                  setTimeout(() => handleClick(item.pagelink), 100);
                              }
                          }}
                          className={`${sidemenucss.sidemenuItem} ${activeItem === item.label ? sidemenucss.sidemenuItemActive : ''}`}
                      >   
                          <span className={sidemenucss.sidemenuItemname}> 
                              <div className={sidemenucss.sideMenuItemContainer}>
                                  {item.label} 
                                  <div className={sidemenucss.submenuIcon}>
                                      {/* {item.subMenu ? (
                                          <SubMenuIcon className={`${sidemenucss.submenuIconSvg} ${hideUnHideSubMenu === 'A' ? null : sidemenucss.rotatedIcon}`} />
                                      ) : null} */}
                                  </div>
                              </div> 
                          </span>
                      </li>

                      {item.subMenu ? (
                          <div className={`${sidemenucss.submenuContainer} ${hideUnHideSubMenu === 'A' ? sidemenucss.sideMenuShow : sidemenucss.sideMenuHide}`}>
                              {item.subMenu.map((sub, idx) => (
                                  <div
                                      key={idx}
                                      className={`${sidemenucss.submenuItem} ${activeItemSubMenu === sub.label ? sidemenucss.activeSubMenu : null}`}
                                      onClick={() => handleClick(sub.pagelink)}
                                  >
                                      {sub.label}
                                  </div>
                              ))}
                          </div>
                      ) : null}
                  </div>
              ))}
          </ul>
      </div>
  </div>
    
    
  );
};

export default CompanyEditSideMenu;
